'use strict'
import controller from './seguimiento.controller';
import template from './seguimiento.html';

const SeguimientoComponent = {
	bindings:{
		proyecto: '=',
		modoVista: '<'
	},
	controller,
	template
};

export default SeguimientoComponent;


// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/seguimiento/seguimiento.component.js